// Toast event emitter
import React from 'react';
import { ToastProps } from '../types/toast';

let toastEmitter: ((toast: Omit<ToastProps, 'id'> & { toastId?: string }) => void) | null = null;
let loadingToastId: string | null = null;

export const setToastEmitter = (emitter: ((toast: Omit<ToastProps, 'id'> & { toastId?: string }) => void) | null) => {
  toastEmitter = emitter;
};

export const notify = {
  success: (message: string | React.ReactNode, duration?: number) => {
    if (toastEmitter) {
      // Dismiss any loading toast first
      if (loadingToastId) {
        toastEmitter({
          type: 'dismiss',
          message: '',
          toastId: loadingToastId
        });
        loadingToastId = null;
      }
      
      toastEmitter({
        type: 'success',
        message,
        duration: duration ?? 4000,
      });
    }
  },
  error: (message: string | React.ReactNode, duration?: number) => {
    if (toastEmitter) {
      // Dismiss any loading toast first
      if (loadingToastId) {
        toastEmitter({
          type: 'dismiss',
          message: '',
          toastId: loadingToastId
        });
        loadingToastId = null;
      }

      toastEmitter({
        type: 'error',
        message,
        duration: duration ?? 4000,
      });
    }
  },
  info: (message: string | React.ReactNode, duration?: number) => {
    if (toastEmitter) {
      // Dismiss any loading toast first
      if (loadingToastId) {
        toastEmitter({
          type: 'dismiss',
          message: '',
          toastId: loadingToastId
        });
        loadingToastId = null;
      }

      toastEmitter({
        type: 'info',
        message,
        duration: duration ?? 5000,
      });
    }
  },
  loading: (message: string | React.ReactNode) => {
    if (toastEmitter) {
      // Store the loading toast ID
      loadingToastId = Math.random().toString(36).substr(2, 9);
      toastEmitter({
        type: 'loading',
        message,
        toastId: loadingToastId
      });
    }
    return loadingToastId;
  },
  dismiss: (id: string) => {
    if (toastEmitter) {
      toastEmitter({
        type: 'dismiss',
        message: '',
        toastId: id
      });
      if (id === loadingToastId) {
        loadingToastId = null;
      }
    }
  },
};
